// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exp-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  min-width: 0;
}

.exp-form__section {
  padding-bottom: 16px;
  border-bottom: 1px solid #F1F5F9;
}

.exp-form__section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.exp-form__section-copy {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #64748B;
}

.exp-form__field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.exp-form__label {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  line-height: 1.3;
}

.exp-form__req {
  color: #F43F5E;
  font-weight: 600;
}

.exp-form__hint {
  margin: 6px 0 0;
  font-size: 11px;
  line-height: 1.45;
  color: #94A3B8;
}

.exp-form .ant-form-item {
  margin-bottom: 0 !important;
}

.exp-form .ant-form-item-label,
.exp-form .ant-form-item-feedback-icon {
  display: none !important;
}

.exp-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

.exp-form .ant-select,
.exp-form .ant-input-number,
.exp-form .ant-input-number-group-wrapper {
  width: 100% !important;
}

.exp-form .ant-select-single .ant-select-selector,
.exp-form .ant-input-number,
.exp-form .ant-input-number-group-addon {
  height: 36px !important;
  min-height: 36px !important;
  border-color: #E2E8F0 !important;
  box-shadow: none !important;
}

.exp-form .ant-select-single .ant-select-selector {
  border-radius: 8px !important;
  padding-inline: 12px !important;
  display: flex !important;
  align-items: center;
}

.exp-form .ant-select-single .ant-select-selection-item,
.exp-form .ant-select-single .ant-select-selection-placeholder {
  line-height: 34px !important;
  font-size: 12px !important;
}

.exp-form .ant-input-number-group-addon {
  padding: 0 12px !important;
  border-radius: 0 8px 8px 0 !important;
  background: #F8FAFC !important;
  color: #475569 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  font-variant-numeric: tabular-nums;
}

.exp-form .ant-input-number {
  border-radius: 8px 0 0 8px !important;
}

.exp-form .ant-input-number-input {
  height: 34px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  font-variant-numeric: tabular-nums;
  color: #1E293B;
}

.exp-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
.exp-form .ant-input-number:hover,
.exp-form .ant-input-number-group-wrapper:hover .ant-input-number,
.exp-form .ant-input-number-group-wrapper:hover .ant-input-number-group-addon {
  border-color: #CBD5E1 !important;
}

.exp-form .ant-select-focused .ant-select-selector,
.exp-form .ant-input-number-focused,
.exp-form .ant-input-number-group-wrapper:focus-within .ant-input-number,
.exp-form .ant-input-number-group-wrapper:focus-within .ant-input-number-group-addon {
  border-color: #0EA5E9 !important;
  box-shadow: none !important;
}

.exp-form .ant-input-number-group-wrapper:focus-within {
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);
  border-radius: 8px;
}

.exp-form .ant-form-item-has-error .ant-select-selector,
.exp-form .ant-form-item-has-error .ant-input-number,
.exp-form .ant-form-item-has-error .ant-input-number-group-addon {
  border-color: #F43F5E !important;
}

.exp-form__note {
  box-sizing: border-box;
  width: 100%;
  height: 96px;
  padding: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  resize: none;
  font-size: 14px;
  line-height: 1.5;
  color: #1E293B;
}

.exp-form__note::placeholder {
  color: #94A3B8;
}

.exp-form__note:hover {
  border-color: #CBD5E1;
}

.exp-form__note:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);
}

[dir='rtl'] .exp-form .ant-input-number {
  border-radius: 0 8px 8px 0 !important;
}

[dir='rtl'] .exp-form .ant-input-number-group-addon {
  border-radius: 8px 0 0 8px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/accounting/transactions/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;EAIE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".exp-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  min-width: 0;\n}\n\n.exp-form__section {\n  padding-bottom: 16px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.exp-form__section-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.exp-form__section-copy {\n  margin: 2px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748B;\n}\n\n.exp-form__field {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.exp-form__label {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.exp-form__req {\n  color: #F43F5E;\n  font-weight: 600;\n}\n\n.exp-form__hint {\n  margin: 6px 0 0;\n  font-size: 11px;\n  line-height: 1.45;\n  color: #94A3B8;\n}\n\n.exp-form .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.exp-form .ant-form-item-label,\n.exp-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.exp-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.exp-form .ant-select,\n.exp-form .ant-input-number,\n.exp-form .ant-input-number-group-wrapper {\n  width: 100% !important;\n}\n\n.exp-form .ant-select-single .ant-select-selector,\n.exp-form .ant-input-number,\n.exp-form .ant-input-number-group-addon {\n  height: 36px !important;\n  min-height: 36px !important;\n  border-color: #E2E8F0 !important;\n  box-shadow: none !important;\n}\n\n.exp-form .ant-select-single .ant-select-selector {\n  border-radius: 8px !important;\n  padding-inline: 12px !important;\n  display: flex !important;\n  align-items: center;\n}\n\n.exp-form .ant-select-single .ant-select-selection-item,\n.exp-form .ant-select-single .ant-select-selection-placeholder {\n  line-height: 34px !important;\n  font-size: 12px !important;\n}\n\n.exp-form .ant-input-number-group-addon {\n  padding: 0 12px !important;\n  border-radius: 0 8px 8px 0 !important;\n  background: #F8FAFC !important;\n  color: #475569 !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  font-variant-numeric: tabular-nums;\n}\n\n.exp-form .ant-input-number {\n  border-radius: 8px 0 0 8px !important;\n}\n\n.exp-form .ant-input-number-input {\n  height: 34px !important;\n  padding: 0 12px !important;\n  font-size: 12px !important;\n  font-variant-numeric: tabular-nums;\n  color: #1E293B;\n}\n\n.exp-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector,\n.exp-form .ant-input-number:hover,\n.exp-form .ant-input-number-group-wrapper:hover .ant-input-number,\n.exp-form .ant-input-number-group-wrapper:hover .ant-input-number-group-addon {\n  border-color: #CBD5E1 !important;\n}\n\n.exp-form .ant-select-focused .ant-select-selector,\n.exp-form .ant-input-number-focused,\n.exp-form .ant-input-number-group-wrapper:focus-within .ant-input-number,\n.exp-form .ant-input-number-group-wrapper:focus-within .ant-input-number-group-addon {\n  border-color: #0EA5E9 !important;\n  box-shadow: none !important;\n}\n\n.exp-form .ant-input-number-group-wrapper:focus-within {\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);\n  border-radius: 8px;\n}\n\n.exp-form .ant-form-item-has-error .ant-select-selector,\n.exp-form .ant-form-item-has-error .ant-input-number,\n.exp-form .ant-form-item-has-error .ant-input-number-group-addon {\n  border-color: #F43F5E !important;\n}\n\n.exp-form__note {\n  box-sizing: border-box;\n  width: 100%;\n  height: 96px;\n  padding: 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  resize: none;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #1E293B;\n}\n\n.exp-form__note::placeholder {\n  color: #94A3B8;\n}\n\n.exp-form__note:hover {\n  border-color: #CBD5E1;\n}\n\n.exp-form__note:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);\n}\n\n[dir='rtl'] .exp-form .ant-input-number {\n  border-radius: 0 8px 8px 0 !important;\n}\n\n[dir='rtl'] .exp-form .ant-input-number-group-addon {\n  border-radius: 8px 0 0 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
